var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.006,
    height: 20.006,
    viewBox: "0 0 20.006 20.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_22._Information",
    "data-name": "22. Information",
    d: "M10,0a10,10,0,1,0,10,10A10,10,0,0,0,10,0Zm.834,15a.834.834,0,0,1-1.667,0V9.169H8.336a.834.834,0,0,1,0-1.667H10a.834.834,0,0,1,.834.834ZM10.02,5.835a.834.834,0,0,1-.008-1.667h.008a.834.834,0,0,1,0,1.667Z",
    fill: "#3f81f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/Information_icon.b4e1105722820315d8ee909669dd2b57.svg";
export { ForwardRef as ReactComponent };